module.exports = __webpack_public_path__ + "img/logo-invoize.a69de8a8.svg";